// extracted by mini-css-extract-plugin
export default {"serviceItemText":"ServiceList_serviceItemText__n4N8l","statesAvailable":"ServiceList_statesAvailable__+T+M5"};